import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const blocking = {
  blockItem: lazyModuleMethod(() => import('./blockItem'), 'default'),
  unblockItem: lazyModuleMethod(() => import('./unblockItem'), 'default'),
  fetchBlockingRichBlocksList: lazyModuleMethod(
    () => import('./fetchBlockingRichBlocksList'),
    'default'
  ),
}
